export const APP_ROUTES = {
    GOAL_SETTING: '/goalsetting',
    CREATE_GOAL: '/goalsetting/create',
    GOAL_SALES_DETAIL: '/goalsetting/salesgoal/details',
    GOAL_CUSTOMERS_DETAIL: '/goalsetting/customersgoal/details',
    EDIT_SALES_GOAL: '/goalsetting/salesgoal/edit',
    EDIT_CUSTOMERS_GOAL: '/goalsetting/customersgoal/edit',
    SALE_MINIAPP_GOAL: '/sales',
    CUSTOMER: '/customers',
    COMPETITION: '/competition',
    SALES: '/sales',
    SALES_TWO_WEEKS_AGO: '/sales/two-weeks-ago',
};
